"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEditableTextRestriction = exports.editableTextRestrictionRuleSet = exports.isEditableTextDefaultData = exports.editableTextDefaultDataRuleSet = exports.isEditableTextDefaultDataStyleRestriction = exports.editableTextDefaultDataStyleRestrictionRuleSet = exports.isEditableTextDefaultDataStyle = exports.editableTextDefaultDataStyleRuleSet = void 0;
const typeguard_1 = require("../../types/typeguard");
exports.editableTextDefaultDataStyleRuleSet = {
  color: (0, typeguard_1.optional)(typeguard_1.isString),
  fontSize: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  fontStyle: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  fontWeight: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  fontHeight: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  textTranform: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  textAlign: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  verticalAlign: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  fontFamily: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  paddingTop: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString)
};
const isEditableTextDefaultDataStyle = etdds => (0, typeguard_1.isType)(etdds, exports.editableTextDefaultDataStyleRuleSet);
exports.isEditableTextDefaultDataStyle = isEditableTextDefaultDataStyle;
exports.editableTextDefaultDataStyleRestrictionRuleSet = {
  color: (0, typeguard_1.optional)(value => value ? (0, typeguard_1.isString)(value) || Array.isArray(value) : true),
  fontSize: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  fontStyle: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  fontWeight: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  fontHeight: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  textTranform: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  textAlign: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  verticalAlign: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  minimumFontSize: (0, typeguard_1.optional)(typeguard_1.isNumber),
  fontFamily: value => value ? (0, typeguard_1.isString)(value) || Array.isArray(value) : true,
  paddingTop: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString)
};
const isEditableTextDefaultDataStyleRestriction = etddsr => (0, typeguard_1.isType)(etddsr, exports.editableTextDefaultDataStyleRestrictionRuleSet);
exports.isEditableTextDefaultDataStyleRestriction = isEditableTextDefaultDataStyleRestriction;
exports.editableTextDefaultDataRuleSet = {
  content: (0, typeguard_1.optional)(typeguard_1.isString),
  assetId: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  styleRestrictions: (0, typeguard_1.optional)(exports.isEditableTextDefaultDataStyleRestriction),
  style: (0, typeguard_1.optional)(exports.isEditableTextDefaultDataStyle)
};
const isEditableTextDefaultData = etdd => (0, typeguard_1.isType)(etdd, exports.editableTextDefaultDataRuleSet);
exports.isEditableTextDefaultData = isEditableTextDefaultData;
exports.editableTextRestrictionRuleSet = {
  invalidChars: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  charLength: value => typeof value === 'string' || typeof value === 'number'
};
const isEditableTextRestriction = etr => (0, typeguard_1.isType)(etr, exports.editableTextRestrictionRuleSet);
exports.isEditableTextRestriction = isEditableTextRestriction;